module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profiler"
  }, [_c('div', {
    staticClass: "profile-left"
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('img', {
    attrs: {
      "src": _vm.headPic
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uploads"
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.selectFile
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "set-head text-primary",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_set_head')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "profile-right"
  }, [_c('div', {
    staticClass: "profile-group profile-inline"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('user_center_email')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "profile-input"
  }, [_vm._v("\n                " + _vm._s(_vm.userinfo.email) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "profile-group profile-inline"
  }, [_c('label', [_vm._v("iPoint:")]), _vm._v(" "), _c('div', {
    staticClass: "profile-input"
  }, [_c('span', {
    staticClass: "ipoint-num"
  }, [_vm._v(_vm._s(_vm.userinfo.ipoint))]), _vm._v(" "), _c('button', {
    staticClass: "btn-modify-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToTopUp
    }
  }, [_vm._v(_vm._s(_vm.$t('top_up')))])])]), _vm._v(" "), _c('div', {
    staticClass: "profile-group profile-inline"
  }, [_c('div', {
    staticClass: "profile-input input-space"
  }, [_c('span', {
    staticClass: "profile-name"
  }, [_vm._v(_vm._s(_vm.userinfo.nickname))]), _vm._v(" "), _c('button', {
    staticClass: "btn-modify btn-big btn-text",
    on: {
      "click": function($event) {
        _vm.isShowModName = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/icon_edit_blue.png"),
      "width": "26"
    }
  }), _vm._v(_vm._s(_vm.$t('user_center_btn_modify')) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "profile-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('user_center_manage_address')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "profile-input"
  }, [_vm._l((_vm.address), function(item, index) {
    return (_vm.address) ? _c('addr', {
      key: index,
      attrs: {
        "addr": item,
        "checked-num": index,
        "id": item.address_id
      },
      on: {
        "checked": function($event) {
          _vm.setChecked(index)
        },
        "deladdr": function($event) {
          _vm.delAddress(index)
        },
        "modifyaddr": _vm.modifyAddr
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('button', {
    staticClass: "btn-modify btn-big",
    on: {
      "click": function($event) {
        _vm.addAddress = true
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('user_center_add_address')) + "\n                    ")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "profile-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('user_center_security')))]), _vm._v(" "), _c('div', {
    staticClass: "profile-input"
  }, [_c('h2', {
    staticClass: "security-title"
  }, [_vm._v(_vm._s(_vm.$t('user_center_account_password')))]), _vm._v(" "), _c('div', {
    staticClass: "profile-security-list"
  }, [_c('p', {
    staticClass: "security-content"
  }, [_vm._v(_vm._s(_vm.$t('user_center_account_password_tip')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn-modify btn-big btn-text",
    on: {
      "click": function($event) {
        _vm.change_password_modal = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/icon_edit_blue.png"),
      "width": "26"
    }
  }), _vm._v(_vm._s(_vm.$t('user_center_btn_modify')) + "\n                        ")])])]), _vm._v(" "), _c('h2', {
    staticClass: "security-title"
  }, [_vm._v(_vm._s(_vm.$t('user_center_Safety phone')))]), _vm._v(" "), _c('div', {
    staticClass: "profile-security-list"
  }, [(_vm.isNumber) ? _c('p', {
    staticClass: "security-content"
  }, [_vm._v("\n                       " + _vm._s(_vm.$t('user_center_bind_your_number')) + "\n                    ")]) : _c('p', {
    staticClass: "security-content"
  }, [_vm._v("\n                        " + _vm._s(_vm.add_phone) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.isNumber) ? _c('button', {
    staticClass: "btn-modify btn-big btn-text",
    on: {
      "click": function($event) {
        _vm.bindthephone = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/icon_edit_blue.png"),
      "width": "26"
    }
  }), _vm._v(_vm._s(_vm.$t('add_number')) + "\n                        ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "profile-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('my_card')))]), _vm._v(" "), _c('div', {
    staticClass: "profile-input"
  }, [(_vm.null_card) ? _c('p', {
    staticClass: "security-content",
    staticStyle: {
      "width": "100%",
      "font-size": "14px",
      "color": "#5E6D82"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_security_bind_card'))), _c('router-link', {
    staticStyle: {
      "color": "#0084ff"
    },
    attrs: {
      "to": {
        name: 'app'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('download_btn')))]), _vm._v(_vm._s(_vm.$t('user_center_security_bind_card1')))], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "card-list"
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "lg": 8,
      "md": 8,
      "sm": 12,
      "xs": 12
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mogos_card),
      expression: "mogos_card"
    }],
    staticClass: "mogos_card",
    attrs: {
      "src": require("../../assets/profile/mogos_200@2x.png"),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8,
      "md": 8,
      "sm": 12,
      "xs": 12
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ichat_card),
      expression: "ichat_card"
    }],
    staticClass: "ichat_card",
    attrs: {
      "src": require("../../assets/profile/ichat_200@2x.png"),
      "alt": "",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8,
      "md": 8,
      "sm": 12,
      "xs": 12
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iglobal_card),
      expression: "iglobal_card"
    }],
    staticClass: "iglobal_card",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "src": require("../../assets/store/iglobal.png"),
      "alt": "",
      "width": "110%"
    }
  })])], 1)], 1)])])]), _vm._v(" "), _c('modal', {
    staticClass: "modal-group-scc",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.change_password_modal),
      callback: function($$v) {
        _vm.change_password_modal = $$v
      },
      expression: "change_password_modal"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "change_password-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('user_center_account_password_change_psw')))])]), _vm._v(" "), _c('div', {
    staticClass: "change_password-main"
  }, [_c('p', {
    staticClass: "change_password_p"
  }, [_vm._v(_vm._s(_vm.$t('user_center_account_password_original_psw')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "change_password_input",
    class: {
      'is-error': _vm.errors.has('change_passeword_old_psw')
    },
    attrs: {
      "name": "change_passeword_old_psw",
      "type": "text",
      "placeholder": _vm.$t('user_center_account_password_original_psw')
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "change_password-main"
  }, [_c('p', {
    staticClass: "change_password_p"
  }, [_vm._v(_vm._s(_vm.$t('user_center_account_password_new_psw')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    staticClass: "change_password_input",
    class: {
      'is-error': _vm.errors.has('change_password_new_password1')
    },
    attrs: {
      "name": "change_password_new_password1",
      "type": "text",
      "placeholder": _vm.$t('user_center_account_password_new_psw')
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "change_password-main"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    staticClass: "change_password_input",
    class: {
      'is-error': _vm.errors.has('change_password_new_password2')
    },
    attrs: {
      "name": "change_password_new_password2",
      "type": "text",
      "placeholder": _vm.$t('user_center_account_password_re_psw')
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "change_password-nex-btn"
  }, [_c('button', {
    on: {
      "click": _vm.change_password
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), _c('modal', {
    staticClass: "addAddress_modal",
    on: {
      "on-cancel": _vm.cancelAddress
    },
    model: {
      value: (_vm.addAddress),
      callback: function($$v) {
        _vm.addAddress = $$v
      },
      expression: "addAddress"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "add-address-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('user_center_add_address_tittle')))])]), _vm._v(" "), (_vm.addAddressGroup.address_id !== null) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.address_id),
      expression: "addAddressGroup.address_id"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.addAddressGroup.address_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "address_id", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "addr_modal"
  }, [_c('p', {
    staticClass: "addr_modal_tips"
  }, [_vm._v(_vm._s(_vm.$t('user_center_Coupons_Use_tips')) + ": "), _c('span', [_vm._v("*")]), _vm._v(_vm._s(_vm.$t('add_address_must_item')))]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('add_address_area'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.country),
      expression: "addAddressGroup.country"
    }],
    attrs: {
      "name": "addAddressGroup_country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.addAddressGroup, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countrys), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v("   " + _vm._s(item.country_name) + "\n                        ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('add_address_address'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item2"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.address),
      expression: "addAddressGroup.address"
    }],
    class: {
      'is-error': _vm.errors.has('addAddressGroup_address')
    },
    attrs: {
      "cols": "30",
      "rows": "6",
      "placeholder": _vm.$t('add_address_address_full'),
      "name": "addAddressGroup_address"
    },
    domProps: {
      "value": (_vm.addAddressGroup.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('add_address_zip_code')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.zipcode),
      expression: "addAddressGroup.zipcode"
    }],
    class: {
      'is-error': _vm.errors.has('addAddressGroup_zipcode')
    },
    attrs: {
      "type": "text",
      "name": "addAddressGroup_zipcode",
      "placeholder": _vm.$t('add_address_zip_code_full')
    },
    domProps: {
      "value": (_vm.addAddressGroup.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "zipcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('about_ifree_join_sub_name'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.name),
      expression: "addAddressGroup.name"
    }],
    class: {
      'is-error': _vm.errors.has('addAddressGroup_last_name')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('add_address_first_name_full'),
      "name": "addAddressGroup_last_name"
    },
    domProps: {
      "value": (_vm.addAddressGroup.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('about_ifree_join_sub_number'))), _c('span', [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.area_code),
      expression: "addAddressGroup.area_code"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.addAddressGroup, "area_code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.cityiso), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.area_code
      }
    }, [_vm._v("\n                            " + _vm._s(item.area_code) + " " + _vm._s(item.name) + "\n                        ")])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:11'),
      expression: "'required|min:11'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.addAddressGroup.mobile),
      expression: "addAddressGroup.mobile"
    }],
    staticClass: "form-input",
    class: {
      'is-error': _vm.errors.has('bind_phone')
    },
    attrs: {
      "name": "bind_phone",
      "type": "text",
      "placeholder": this.$t('add_number_number')
    },
    domProps: {
      "value": (_vm.addAddressGroup.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addAddressGroup, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('Checkbox', {
    staticClass: "checkALL",
    staticStyle: {
      "font-size": "14px",
      "color": "#5E6D82"
    },
    on: {
      "on-change": _vm.check_default
    },
    model: {
      value: (_vm.default_single),
      callback: function($$v) {
        _vm.default_single = $$v
      },
      expression: "default_single"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('add_address_defult_address')) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "addr_group"
  }, [_c('div', {
    staticClass: "addr_laber"
  }), _vm._v(" "), _c('div', {
    staticClass: "addr_item1"
  }, [_c('button', {
    staticClass: "btn-pt btn-blue",
    on: {
      "click": _vm.saveAddress
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('determine_btn')) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), _c('modal', {
    staticClass: "change_nickname",
    attrs: {
      "title": _vm.$t('user_change_nickname')
    },
    model: {
      value: (_vm.isShowModName),
      callback: function($$v) {
        _vm.isShowModName = $$v
      },
      expression: "isShowModName"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userinfo.user_id),
      expression: "userinfo.user_id"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.userinfo.user_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userinfo, "user_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userinfo.nickname),
      expression: "userinfo.nickname"
    }],
    class: {
      'is-error': _vm.errors.has('modifyNickName')
    },
    attrs: {
      "type": "text",
      "name": "modifyNickName"
    },
    domProps: {
      "value": (_vm.userinfo.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userinfo, "nickname", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "profile-group",
    attrs: {
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "btn-big btn-modify-sm",
    staticStyle: {
      "margin": "0 auto"
    },
    on: {
      "click": _vm.modifyNickName
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('user_center_btn_modify')) + "\n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), _c('modal', {
    staticClass: "modal-group-scc",
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.bindthephone),
      callback: function($$v) {
        _vm.bindthephone = $$v
      },
      expression: "bindthephone"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "change_password-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('add_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "change_password-main"
  }, [_c('p', {
    staticClass: "change_password_p"
  }, [_vm._v(_vm._s(_vm.$t('add_number_number')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-inline",
    attrs: {
      "id": "bind_the_phone"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bind_iso),
      expression: "bind_iso"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bind_iso = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.cityiso), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.area_code
      }
    }, [_vm._v("\n                            " + _vm._s(item.area_code) + " " + _vm._s(item.name) + "\n                        ")])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:11'),
      expression: "'required|min:11'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.add_mobile),
      expression: "add_mobile"
    }],
    staticClass: "form-input",
    class: {
      'is-error': _vm.errors.has('bind_phone')
    },
    attrs: {
      "name": "bind_phone",
      "type": "text",
      "placeholder": this.$t('add_number_number')
    },
    domProps: {
      "value": (_vm.add_mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.add_mobile = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "change_password-main"
  }, [_c('div', {
    staticClass: "profile-security-list-1"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:4'),
      expression: "'required|min:4'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "change_password_input",
    class: {
      'is-error': _vm.errors.has('verification_code')
    },
    attrs: {
      "name": "verification_code",
      "type": "text",
      "placeholder": this.$t('add_number_verification_code')
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "btn-modify btn-big",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('send_code')) + "\n                        ")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.count) + " s")])])]), _vm._v(" "), _c('div', {
    staticClass: "change_password-nex-btn"
  }, [_c('button', {
    on: {
      "click": _vm.add_password,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.add_password($event)
      }
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v("TOP")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Service")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cabd64e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Profile.vue
// module id = 804
// module chunks = 0